import { render, staticRenderFns } from "./NCLDC2024.vue?vue&type=template&id=9ddaab88&scoped=true"
import script from "./NCLDC2024.vue?vue&type=script&lang=js"
export * from "./NCLDC2024.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ddaab88",
  null
  
)

export default component.exports